export const T = {
  en_GB: {
    addFilter: "Add filter",
    standardFields: "Standard Fields",
    clientFields: "Client Fields",
    remove: "Remove filter",
    unavailableFilter: "Unavailable filter",
  },
  nb_NO: {
    addFilter: "Legg til filter",
    standardFields: "Standardfelt",
    clientFields: "Kundefelt",
    remove: "Fjern filter",
    unavailableFilter: "Utilgjengelig filter",
  },
} as const;
